"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categories = void 0;
exports.categories = new Set([
    { text: 'Labor', value: 'LABOR' },
    { text: 'Overhead Labor', value: 'OVERHEAD_LABOR' },
    { text: 'Materials', value: 'MATERIALS' },
    { text: 'Equipment', value: 'EQUIPMENT' },
    { text: 'Subcontractors', value: 'SUBCONTRACTORS' },
    { text: 'Overhead', value: 'OVERHEAD' },
    { text: 'Other', value: 'OTHER' },
]);
